export class User {
  email: string;
  token: string;
  username: string;
  bio: string;
  image: string;
  facebookLinked: boolean;
  twitterLinked: boolean;
  googleLinked: boolean;
  createdAt: string;
  updatedAt: string;
}
